import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35e60976"),n=n(),_popScopeId(),n)
const _hoisted_1 = { slot: "dialog-header" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { slot: "dialog-body" }
const _hoisted_4 = { class: "picture-edit__content" }
const _hoisted_5 = { class: "picture-edit__cropbox" }
const _hoisted_6 = { class: "thumbnail__wrapper" }
const _hoisted_7 = {
  key: 0,
  class: "loader-container"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 0,
  class: "cropper-controler"
}
const _hoisted_13 = { class: "picture-edit__cta" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "picture-edit__samples" }
const _hoisted_18 = { class: "picture-edit__samples__content" }
const _hoisted_19 = { class: "picture-list__title" }
const _hoisted_20 = { class: "picture-list" }
const _hoisted_21 = { class: "picture-list__item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("picture", {
  class: "",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("source", {
    src: "https://dam.malt.com/profile/ProfilePictureSample001?w=122&q=90",
    type: "image/webp"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "picture-list__exemple loaded",
    alt: "",
    src: "https://dam.malt.com/profile/ProfilePictureSample001?w=122&q=90"
  })
], -1))
const _hoisted_23 = { class: "picture-list__item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("picture", {
  class: "",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("source", {
    src: "https://dam.malt.com/profile/ProfilePictureSample002?w=122&q=90",
    type: "image/webp"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "picture-list__exemple loaded",
    alt: "",
    src: "https://dam.malt.com/profile/ProfilePictureSample002?w=122&q=90"
  })
], -1))
const _hoisted_25 = { class: "picture-list__item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("picture", {
  class: "",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("source", {
    src: "https://dam.malt.com/profile/ProfilePictureSample003?w=122&q=90",
    type: "image/webp"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "picture-list__exemple loaded",
    alt: "",
    src: "https://dam.malt.com/profile/ProfilePictureSample003?w=122&q=90"
  })
], -1))
const _hoisted_27 = { class: "picture-list__title" }
const _hoisted_28 = { class: "picture-list" }
const _hoisted_29 = { class: "picture-list__item" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: "//dam.malt.com/profile/lunette"
}, null, -1))
const _hoisted_31 = { class: "picture-list__item" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: "//dam.malt.com/profile/cadrage"
}, null, -1))
const _hoisted_33 = { class: "picture-list__item" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: "//dam.malt.com/profile/apn"
}, null, -1))
const _hoisted_35 = { class: "picture-edit__actions" }
const _hoisted_36 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_joy_icon = _resolveComponent("joy-icon")!
  const _component_joy_dropzone = _resolveComponent("joy-dropzone")!
  const _component_vue_cropper = _resolveComponent("vue-cropper")!
  const _component_joy_dialog = _resolveComponent("joy-dialog")!

  return (_openBlock(), _createBlock(_component_joy_dialog, {
    ref: "dialogRef",
    size: "large"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_joy_icon, {
          name: "camera",
          size: "small",
          class: "header__icon"
        }),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$msg('profile.picture.modal.title')), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          id: "profilePhotoForm",
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.uploadNewPhoto && _ctx.uploadNewPhoto(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
                  : _createCommentVNode("", true),
                _withDirectives(_createVNode(_component_joy_dropzone, {
                  "id-dropzone": "profileUploadPhoto",
                  accept: ['image/jpeg', 'image/png'],
                  "button-text": _ctx.$msg('image.edit.upload'),
                  "description-text": _ctx.$msg('file.dropzone.title'),
                  "description-strong-text": "",
                  onJoyDropzoneDroppedFiles: _ctx.changePhoto
                }, null, 8, ["button-text", "description-text", "onJoyDropzoneDroppedFiles"]), [
                  [_vShow, !_ctx.file]
                ]),
                _withDirectives(_createElementVNode("img", {
                  class: _normalizeClass(["thumbnail-upload", {loading: _ctx.loading}]),
                  alt: "",
                  src: _ctx.imageUrl
                }, null, 10, _hoisted_10), [
                  [_vShow, _ctx.file && !_ctx.cropping && !_ctx.blob]
                ]),
                (_ctx.blob && !_ctx.cropping)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      ref: "croppedImage",
                      class: _normalizeClass(["thumbnail-upload", {loading: _ctx.loading}]),
                      alt: "",
                      src: _ctx.croppedImageDataURL
                    }, null, 10, _hoisted_11))
                  : _createCommentVNode("", true),
                (_ctx.file && _ctx.cropping)
                  ? (_openBlock(), _createBlock(_component_vue_cropper, {
                      key: 2,
                      ref: "cropper",
                      src: _ctx.imageUrl,
                      checkOrientation: false,
                      aspectRatio: 1,
                      viewMode: 2,
                      dragMode: 'move',
                      containerStyle: {'max-height': '280px'},
                      imgStyle: {height: '100%'},
                      alt: "Source Image"
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.cropping)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("button", {
                      class: "joy-btn joy-btn_secondary joy-btn_xsmall",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.zoom(-0.2)), ["stop","prevent"]))
                    }, "Zoom -"),
                    _createElementVNode("button", {
                      class: "joy-btn joy-btn_secondary joy-btn_xsmall",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.zoom(0.2)), ["stop","prevent"]))
                    }, "Zoom +")
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_13, [
                (_ctx.file)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "joy-btn joy-btn_secondary joy-btn_xsmall",
                      disabled: _ctx.loading,
                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.clearFile()), ["stop","prevent"]))
                    }, _toDisplayString(_ctx.$msg('profile.picture.cta.change')), 9, _hoisted_14))
                  : _createCommentVNode("", true),
                (_ctx.file && !_ctx.cropping)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "joy-btn joy-btn_secondary joy-btn_xsmall",
                      disabled: _ctx.loading,
                      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.cropFile()), ["stop","prevent"]))
                    }, _toDisplayString(_ctx.$msg('profile.picture.modal.crop.image')), 9, _hoisted_15))
                  : _createCommentVNode("", true),
                (_ctx.cropping)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      class: "joy-btn joy-btn_secondary joy-btn_xsmall",
                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.confirmCropping()), ["stop","prevent"]))
                    }, _toDisplayString(_ctx.$msg('generic.form.validation.label')), 1))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.isButtonDisabled)
                ? (_openBlock(), _createElementBlock("small", {
                    key: 1,
                    class: "image-edit-rules",
                    innerHTML: _ctx.$msg('image.edit.dropzone.rules', 'JPEG, PNG', '500*500', '5')
                  }, null, 8, _hoisted_16))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("figure", _hoisted_18, [
                _createElementVNode("figcaption", _hoisted_19, _toDisplayString(_ctx.$msg('profile.picture.exemples.title')), 1),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createVNode(_component_joy_icon, { name: "check" })
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createVNode(_component_joy_icon, { name: "check" })
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createVNode(_component_joy_icon, { name: "check" })
                  ])
                ])
              ]),
              _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.$msg('profile.picture.rules.title')), 1),
              _createElementVNode("ul", _hoisted_28, [
                _createElementVNode("li", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$msg('profile.picture.rules.no.sunglasses')), 1)
                ]),
                _createElementVNode("li", _hoisted_31, [
                  _hoisted_32,
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$msg('profile.picture.rules.one.face')), 1)
                ]),
                _createElementVNode("li", _hoisted_33, [
                  _hoisted_34,
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$msg('profile.picture.rules.face.cam')), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("button", {
              type: "submit",
              class: "joy-btn joy-btn_default joy-btn_small",
              disabled: _ctx.isButtonDisabled
            }, _toDisplayString(_ctx.$msg('generic.form.save.label')), 9, _hoisted_36)
          ])
        ], 32)
      ])
    ]),
    _: 1
  }, 512))
}